import { useMemo } from 'react';

import { Survey } from '../../../../survey-types';
import * as expressionUtils from '../../../../utils/surveys/expressions';

export const useExpression = ({
  survey,
  selectedExpressionName,
}: {
  survey?: Survey;
  selectedExpressionName?: string;
}) =>
  useMemo(() => {
    return survey ? expressionUtils.getExpressionFromSurvey(survey, selectedExpressionName) : undefined;
  }, [survey, selectedExpressionName]);
